import React, { ReactNode } from 'react'
import styles from './styles/stats-table.module.scss'
import { Player } from 'types/global'

interface Props<T extends Player> {
  side1: T
  side2: T
  stats: { title: string; value: (side: T) => ReactNode }[]
}
function DoubleStatsTable<T extends Player>({ side1, side2, stats }: Props<T>) {
  return (
    <div className={styles.statsContainer}>
      <table>
        <tbody>
          {stats.map(({ title, value }, i) => (
            <tr key={`${title}-${i}`}>
              <td>{value(side1)}</td>
              <th>
                <span className={styles.statsSingleDouble}>{title}</span>
              </th>
              <td>{value(side2)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default DoubleStatsTable
